<template>
  <div v-if="blok.title || blok.text" class="content-headline">
    <h3 class="content-headline__title">{{ blok.title }}</h3>
    <p class="content-headline__text">{{ blok.text }}</p>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  blok: {
    title: string
    text: string
  }
  title: string
  id: string
}>()
</script>

<style lang="scss">
.content-headline {
  display: flex;
  flex-direction: column;
  gap: $sb-size-unit-lg;
  align-items: flex-start;
  color: $sb-color-text-secondary;

  &__title {
    max-width: 300px;
    color: $sb-color-text-primary;
    font-size: $sb-font-size-3xl;
    font-weight: $sb-font-weight-bold;
    line-height: $sb-font-line-height-medium;
  }

  &__text {
    line-height: $sb-font-line-height-distant;
  }
}
</style>
